module.exports = __webpack_public_path__ + "static/CI-Journeys1-89e87ac167451a88e140342f22b4d543.jpg";